import firebase from "../firebase";
import GENRALHELPERS from "../GENRAL-HELPERS";
import allHandeling from "../handeling-all-displays/all-handeling";
import stackDisplay from "../stack-display/display";
import nav from "../home-screen/nav";
import saved from "../saved-and-Followed/saved";
import generateHtml from "./generate-html";



const bigAddsData = [

    // {
    //     title: '¡La nueva versión por fin está disponible!',
    //     context: 'Conoce las nuevas funciones disponibles para mejorar tu experiencia',
    //     inAppLink: '',
    //     outAppLink: '',
    //     buttonLabel: '',
    //     buttonType: '',
    //     addType: '', // video - img
    //     vidUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/big%20add%20videos%2Fland%20scape%20test%20vid.MOV?alt=media&token=620b593c-5687-48cc-a0b7-381e9095c8c1'
    // },
    // {
    //     title: '¡La nueva versión por fin está disponible!',
    //     context: 'Conoce las nuevas funciones disponibles para mejorar tu experiencia',
    //     inAppLink: 'open-notifications',
    //     outAppLink: '',
    //     buttonLabel: '',
    //     buttonType: '',
    //     addType: '', // video - img
    //     vidUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/big%20add%20videos%2Fland%20scape%20test%20vid.MOV?alt=media&token=620b593c-5687-48cc-a0b7-381e9095c8c1'
    // },
    // {
    //     title: '¡La nueva versión por fin está disponible!',
    //     context: 'Conoce las nuevas funciones disponibles para mejorar tu experiencia',
    //     inAppLink: '',
    //     outAppLink: '',
    //     buttonLabel: '',
    //     buttonType: '',
    //     addType: '', // video - img
    //     vidUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/big%20add%20videos%2Fland%20scape%20test%20vid.MOV?alt=media&token=620b593c-5687-48cc-a0b7-381e9095c8c1'
    // },
]


const miniAddsData = [
    {
        title: 'Nueva versión de Mercado MAI',
        context: 'Descubre una experiencia más intuitiva, rápida y optimizada para comprar y vender con mayor facilidad.',
        inAppLink: '',
        outAppLink: '',
        buttonLabel: '',
        buttonType: '',
        imgUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/new%20mai%20features%2Fhome%20screen.png?alt=media&token=1adf350f-1508-4836-a195-e5dd8f45357e'
    },
    {
        title: 'Notificaciones inteligentes',
        context: 'Recibe alertas importantes directamente en tu dispositivo. Personaliza cuándo quieres ser notificado.',
        inAppLink: 'open-notifications',
        outAppLink: '',
        buttonLabel: 'Ver Notificaniónes',
        buttonType: '',
        imgUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/new%20mai%20features%2Fnotifications.png?alt=media&token=eab4a32f-6d8c-4980-a3c8-67077c5305b4'
    },
    {
        title: 'Búsqueda mejorada',
        context: 'Nuestro nuevo motor de búsqueda te permite encontrar listados, negocios y perfiles de vendedores con mayor precisión y profundidad.',
        inAppLink: '',
        outAppLink: '',
        buttonLabel: '',
        buttonType: '',
        imgUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/new%20mai%20features%2Fsearch%20listings.png?alt=media&token=3634864c-b62b-4f1a-96f5-422ad61c8fbb'
    },
    {
        title: 'Comparte listas de negocios',
        context: 'Ahora puedes compartir listas de productos organizadas por categoría. Mantén presionada una lista y selecciona “Compartir”.',
        inAppLink: '',
        outAppLink: '',
        buttonLabel: '',
        buttonType: '',
        imgUrl: 'https://firebasestorage.googleapis.com/v0/b/mqmexico-7c834.firebasestorage.app/o/new%20mai%20features%2Fshare%20list.png?alt=media&token=21cd8595-faaa-46db-b63a-458cff39e823'
    },
];



class adds {


    #videoCarousel = {
        container: null,
        videos: [],
        currentIndex: 0,
        scrollTimeout: null,
        isPaused: false
    };

    #isVideoAddShowOnTimer = false


    constructor() {
        console.log('Adds is live!')

        // setTimeout(() => {
        //     this._initializeMiniAdds()

        //     this._initializeBigAdds()
        // }, 3000);
    }

    _hideDispBigVideoAdd(state, isOnTimer) {
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2BigAddContainer')
        if (state === 'hide') {
            nvHeaderCon2MiniAddContainer.style.display = 'none'
            this._pauseVideoCarousel();
            if (!this.#isVideoAddShowOnTimer && isOnTimer) {
                this.#isVideoAddShowOnTimer = true
            }
        }
        if (!this.#isVideoAddShowOnTimer && state === 'show') {
            console.log('here');


            this._openVideoAgain()
        }
        console.log(this.#isVideoAddShowOnTimer);

    }

    _init() { }

    // START mini adds
    async _initializeMiniAdds() {

        let localAddsList = miniAddsData
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2MiniAddContainer')

        const miniAddsSettings = await firebase._getAnyDocById('adds/miniAdds')

        if (miniAddsSettings.miniAddsOn) {
            localAddsList = []
            for (const id of miniAddsSettings.currentList) {
                const add = await firebase._getAnyDocById(`adds/miniAdds/adds/${id}`)
                localAddsList.push(add)
            }
        } else {
            localAddsList = miniAddsData
        }

        nvHeaderCon2MiniAddContainer.innerHTML = ''
        localAddsList.forEach(add => {
            const addHtml = generateHtml._miniAddGenerator(add)

            nvHeaderCon2MiniAddContainer.insertAdjacentHTML('beforeend', addHtml)
        })

        this._startMiniAddsAutoScroll()
        this._miniAddClickEvent()
    }
    _startMiniAddsAutoScroll() {
        const container = document.getElementById('nvHeaderCon2MiniAddContainer');
        if (!container) return;

        const items = Array.from(container.children);
        if (!items.length) return;

        let currentIndex = 0;
        let autoScrollTimer = null;
        let pauseTimer = null;
        let isPaused = false;
        let autoScroll = false

        /* -------------------- */
        /* Detect Active Slide  */
        /* -------------------- */

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    currentIndex = items.indexOf(entry.target);
                }
            });
        }, {
            root: container,
            threshold: 0.6
        });

        items.forEach(item => observer.observe(item));

        /* -------------------- */
        /* Auto Scroll Engine   */
        /* -------------------- */

        const scheduleNextScroll = () => {
            clearTimeout(autoScrollTimer);

            if (isPaused) return;

            // autoScrollTimer = setTimeout(() => {
            //   currentIndex = (currentIndex + 1) % items.length;
            //   autoScroll = true

            //   container.scrollTo({
            //     left: items[currentIndex].offsetLeft,
            //     behavior: 'smooth'
            //   });


            //   setTimeout(() => {
            //     autoScroll = false
            //   }, 2000)

            //   scheduleNextScroll(); // schedule next 5s after scroll
            // }, 5000);

            autoScrollTimer = setTimeout(() => {

                const nextIndex = (currentIndex + 1) % items.length;
                const isLooping = nextIndex === 0; // 👈 detect wrap

                currentIndex = nextIndex;
                autoScroll = true;

                container.scrollTo({
                    left: items[currentIndex].offsetLeft,
                    behavior: isLooping ? 'auto' : 'smooth' // 👈 key change
                });

                setTimeout(() => {
                    autoScroll = false;
                }, isLooping ? 50 : 2000); // shorter lock for instant jump

                scheduleNextScroll();

            }, 5000);

        };

        const pauseAutoScroll = () => {

            if (autoScroll) return
            isPaused = true;

            clearTimeout(autoScrollTimer);
            clearTimeout(pauseTimer);

            pauseTimer = setTimeout(() => {
                isPaused = false;
                scheduleNextScroll(); // fresh 5s cycle
            }, 15000);
        };

        /* -------------------- */
        /* User Interaction     */
        /* -------------------- */

        const handleInteraction = () => {
            pauseAutoScroll(); // always resets 15s
        };

        container.addEventListener('touchstart', handleInteraction, { passive: true });
        container.addEventListener('mousedown', handleInteraction);
        container.addEventListener('scroll', handleInteraction);

        /* -------------------- */

        scheduleNextScroll(); // start system
    }
    _miniAddClickEvent() {
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2MiniAddContainer')

        nvHeaderCon2MiniAddContainer.addEventListener('click', (e) => {

            console.log('here')
            const isInAdd = e.target.closest('.miniHeaderAddCon1')
            if (!isInAdd) return
            console.log('here')
            const inAppLink = isInAdd.dataset.inapplink
            const outAppLink = isInAdd.dataset.outapplink

            if (inAppLink) {
                console.log(inAppLink)

                if (inAppLink === 'open-notifications') {
                    nav._changeNav('Notification')
                    saved._openNotifications()
                }
            }

            if (outAppLink) {
                GENRALHELPERS._openOutboundLink(outAppLink);
            }



        })
    }


    // END mini adds


    // START big adds
    async _initializeBigAdds() {


        let localAddsList = miniAddsData
        let addCount = 0

        const videoAddsSettings = await firebase._getAnyDocById('adds/videoAdds')
        console.log(videoAddsSettings)

        if (videoAddsSettings.videoAddsOn) {
            localAddsList = []
            for (const id of videoAddsSettings.lists[videoAddsSettings.currentListName]) {
                const add = await firebase._getAnyDocById(`adds/videoAdds/adds/${id}`)
                localAddsList.push(add)
                addCount++
            }
        } else {
            localAddsList = miniAddsData
            return
        }

        console.log(addCount)
        if (addCount < 1) return


        const nvHeaderCon2BigAddContainer = document.getElementById('nvHeaderCon2BigAddContainer')
        const buttonHtml = '<div id="headerAddVideoButtonCloseVideos" class="headerAddVideoButtonCloseVideos">Cerrar Videos</div>'

        nvHeaderCon2BigAddContainer.innerHTML = ''
        nvHeaderCon2BigAddContainer.insertAdjacentHTML('beforeend', buttonHtml)
        localAddsList.forEach(add => {
            const addHtml = generateHtml._bigVideoAddGenerator(add)

            nvHeaderCon2BigAddContainer.insertAdjacentHTML('beforeend', addHtml)

            // allHandeling._translateTheHeaderAcordingToScroll("NVHomeMainContainerBusinesses", true)
            // allHandeling._translateTheHeaderAcordingToScroll("NVHomeMainContainerListings", true)
            // allHandeling._translateTheHeaderAcordingToScroll("NVHomeMainContainerSellers", true)
        })

        // this._startMiniAddsAutoScroll()
        // this._miniAddClickEvent()

        this._initializeVideoControls()
        this._initVideoCarousel()
        this._bigAddClickEvent()

        allHandeling._addHeader3Stage('NVHomeMainContainerListings')
        allHandeling._addHeader3Stage('NVHomeMainContainerBusinesses')
        allHandeling._addHeader3Stage('NVHomeMainContainerSellers')

        allHandeling._listenAddContainerHeightChanges()


    }
    _initializeVideoControls() {
        const videos = document.querySelectorAll('.headerVideoAddCon2Video');

        videos.forEach(container => {
            const video = container.querySelector('video');
            const button = container.querySelector('.videoMuteToggle');

            if (!video || !button) return;

            button.addEventListener('click', (e) => {
                e.stopPropagation(); // prevent triggering parent click

                video.muted = !video.muted;

                button.textContent = video.muted ? 'Audio 🔇' : 'Audio 🔊';
            });
        });
    }


    // _initVideoCarousel() {
    //     const container = document.getElementById("nvHeaderCon2BigAddContainer");
    //     if (!container) return;

    //     const videos = Array.from(
    //         container.querySelectorAll(".headerVideoVideo")
    //     );

    //     if (!videos.length) return;

    //     let currentIndex = 0;
    //     let scrollTimeout = null;

    //     const playVideoAt = (index) => {
    //         videos.forEach((video, i) => {
    //             if (i === index) {
    //                 video.play().catch(() => { });
    //             } else {
    //                 video.pause();
    //                 video.currentTime = 0;
    //             }
    //         });

    //         currentIndex = index;
    //     };

    //     // ✅ Play first video initially
    //     playVideoAt(0);

    //     // ✅ When video ends → go to next
    //     videos.forEach((video, index) => {
    //         video.addEventListener("ended", () => {
    //             const nextIndex = (index + 1) % videos.length;

    //             const nextItem = videos[nextIndex].closest(".headerVideoAddCon1");

    //             nextItem.scrollIntoView({
    //                 behavior: "smooth",
    //                 inline: "center",
    //                 block: "nearest"
    //             });

    //             playVideoAt(nextIndex);
    //         });
    //     });

    //     // ✅ Detect visible video on scroll
    //     container.addEventListener("scroll", () => {

    //         // Pause immediately during scroll
    //         videos[currentIndex].pause();

    //         clearTimeout(scrollTimeout);

    //         scrollTimeout = setTimeout(() => {
    //             const containerRect = container.getBoundingClientRect();

    //             let closestIndex = 0;
    //             let closestDistance = Infinity;

    //             videos.forEach((video, index) => {
    //                 const rect = video.getBoundingClientRect();
    //                 const videoCenter = rect.left + rect.width / 2;
    //                 const containerCenter = containerRect.left + containerRect.width / 2;

    //                 const distance = Math.abs(containerCenter - videoCenter);

    //                 if (distance < closestDistance) {
    //                     closestDistance = distance;
    //                     closestIndex = index;
    //                 }
    //             });

    //             playVideoAt(closestIndex);

    //         }, 150); // wait for scroll to stop
    //     });
    // }

    _initVideoCarousel() {
        const container = document.getElementById("nvHeaderCon2BigAddContainer");
        if (!container) return;

        const videos = Array.from(
            container.querySelectorAll(".headerVideoVideo")
        );

        if (!videos.length) return;

        // Save references
        this.#videoCarousel.container = container;
        this.#videoCarousel.videos = videos;
        this.#videoCarousel.currentIndex = 0;
        this.#videoCarousel.isPaused = false;

        const playVideoAt = (index) => {
            if (this.#videoCarousel.isPaused) return;

            videos.forEach((video, i) => {
                if (i === index) {
                    video.play().catch(() => { });
                } else {
                    video.pause();
                    video.currentTime = 0;
                }
            });

            this.#videoCarousel.currentIndex = index;
        };

        // ▶️ Play first video
        playVideoAt(0);

        // 🔁 Auto advance when video ends
        videos.forEach((video, index) => {
            video.addEventListener("ended", () => {

                if (this.#videoCarousel.isPaused) return;

                const nextIndex = (index + 1) % videos.length;
                const nextItem =
                    videos[nextIndex].closest(".headerVideoAddCon1");

                nextItem.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "nearest"
                });

                playVideoAt(nextIndex);
            });
        });

        // 👆 Scroll detection
        container.addEventListener("scroll", () => {

            if (this.#videoCarousel.isPaused) return;

            videos[this.#videoCarousel.currentIndex].pause();

            clearTimeout(this.#videoCarousel.scrollTimeout);

            this.#videoCarousel.scrollTimeout = setTimeout(() => {

                const containerRect = container.getBoundingClientRect();

                let closestIndex = 0;
                let closestDistance = Infinity;

                videos.forEach((video, index) => {
                    const rect = video.getBoundingClientRect();
                    const videoCenter = rect.left + rect.width / 2;
                    const containerCenter =
                        containerRect.left + containerRect.width / 2;

                    const distance =
                        Math.abs(containerCenter - videoCenter);

                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestIndex = index;
                    }
                });

                playVideoAt(closestIndex);

            }, 150);
        });

        // 👁️ Pause when carousel goes off screen (vertical visibility)
        const visibilityObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {

                    if (!entry.isIntersecting) {
                        // 🔴 Off screen → pause everything
                        this.#videoCarousel.isPaused = true;

                        const currentVideo =
                            videos[this.#videoCarousel.currentIndex];
                        currentVideo?.pause();

                    } else {
                        // 🟢 Back on screen → resume
                        this.#videoCarousel.isPaused = false;

                        const currentVideo =
                            videos[this.#videoCarousel.currentIndex];
                        currentVideo?.play().catch(() => { });
                    }

                });
            },
            {
                root: null, // viewport
                threshold: 0.25 // trigger when at least 25% visible
            }
        );

        visibilityObserver.observe(container);

    }

    _pauseVideoCarousel() {
        if (!this.#videoCarousel.videos.length) return;

        this.#videoCarousel.isPaused = true;

        const current =
            this.#videoCarousel.videos[
            this.#videoCarousel.currentIndex
            ];

        current.pause();
    }
    _resumeVideoCarousel() {
        if (!this.#videoCarousel.videos.length) return;

        this.#videoCarousel.isPaused = false;

        const current =
            this.#videoCarousel.videos[
            this.#videoCarousel.currentIndex
            ];

        current.play().catch(() => { });
    }
    _openVideoAgain() {
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2BigAddContainer')
        if (allHandeling._getIsInSearchState()) return
        if (stackDisplay._getOpenState()) return


        nvHeaderCon2MiniAddContainer.style.display = 'flex';
        this._resumeVideoCarousel();
    }



    _bigAddClickEvent() {
        const nvHeaderCon2MiniAddContainer = document.getElementById('nvHeaderCon2BigAddContainer')

        nvHeaderCon2MiniAddContainer.addEventListener('click', (e) => {

            console.log('here')
            const isInAdd = e.target.closest('.headerVideoAddCon2')
            const isCloseButton = e.target.closest('.headerAddVideoButtonCloseVideos')
            const isActionButton = e.target.closest('.headerVideoAddCon4')
            if (isCloseButton) {

                this._hideDispBigVideoAdd('hide', true)


                const min = 6000; // 1 second
                const max = 8000; // 4 seconds
                // const min = 120000; // 2  minutes
                // const max = 300000; // 5 minutes

                const randomDelay = Math.floor(Math.random() * (max - min + 1)) + min;

                console.log(randomDelay)

                setTimeout(() => {
                    this.#isVideoAddShowOnTimer = false
                    this._hideDispBigVideoAdd('show')

                }, randomDelay);

            }
            if (isInAdd && isActionButton) {
                console.log('here')
                const inAppLink = isInAdd.dataset.inapplink
                const outAppLink = isInAdd.dataset.outapplink

                if (inAppLink) {
                    console.log(inAppLink)

                    if (inAppLink === 'open-notifications') {
                        nav._changeNav('Notification')
                        saved._openNotifications()
                    }
                }

                if (outAppLink) {
                    GENRALHELPERS._openOutboundLink(outAppLink);
                }
            }


        })
    }

    // END big adds

}


export default new adds()